<template>
    <Table
        ref="mt"
        :columns="columns"
        :data="list"
        height="350"
        editMode="grid"
        border
        :formula="formula"
    >
        <template v-slot:isChecked="{ row }">
            <Checkbox
                v-model="row.isChecked"
                :disabled="row.billStatus === '2' || canCorrect === false"
                @on-change="onCheck(row)"
            />
        </template>
    </Table>
</template>

<script>
import { editCell } from '_c/grid/renderCell'
import { groupBy } from '_u/helper'
import { renderAmountText } from '@/views/common/u-contract'
export default {
    name: 'BillCorrection',
    inject: {
        $modal: {
            default: null,
        },
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            list: [],
            dict: {
                payType: this.$dict.NULL,
            },
        }
    },

    computed: {
        canCorrect() {
            return this.$can('feeCorrect')
        },
        columns() {
            return [
                {
                    key: 'title',
                    title: '期数',
                    align: 'left',
                    width: 80,
                },
                {
                    key: 'periodText',
                    title: '账期',
                    align: 'left',
                    width: 180,
                },
                {
                    key: 'bill',
                    title: '账单',
                    align: 'left',
                    minWidth: 120,
                    render: (h, params) => {
                        const list = params.row.bill.split('\r\n')
                        return renderAmountText(h, list, 'div', 'div')
                    },
                },
                {
                    key: 'isChecked',
                    title: '置为已收',
                    align: 'center',
                    width: 70,
                    slot: 'isChecked',
                },
                {
                    key: 'payType',
                    title: '交易方式',
                    align: 'left',
                    width: 140,
                    render: editCell('CellSelect', {
                        props: {
                            optionList: this.dict.payType.toList(),
                        },
                        attrs: {
                            clearable: true,
                        },
                    }),
                    canEdit: ({ row }) =>
                        row.billStatus !== '2' && this.canCorrect,
                },
                {
                    key: 'remark',
                    title: '备注',
                    align: 'left',
                    minWidth: 200,
                    render: editCell('CellInput'),
                    canEdit: ({ row }) => row.billStatus !== '2',
                },
                {
                    key: 'realDate',
                    title: '实际收款日',
                    align: 'left',
                    width: 150,
                    render: editCell('CellDatePicker', {
                        attrs: {
                            type: 'datetime',
                        },
                    }),
                    canEdit: ({ row }) =>
                        row.billStatus !== '2' && this.canCorrect,
                },
            ]
        },
    },
    methods: {
        formula(model) {
            // 校验
            model.verification(
                (d) => d.key == 'payType',
                (d) => [
                    {
                        validator(rule, value, callback, source, options) {
                            if (d.row.isChecked) {
                                if (d.row.payType === '') {
                                    return callback(
                                        new Error('交易方式不能为空')
                                    )
                                }
                            }

                            return callback()
                        },
                    },
                ]
            )
            model.verification(
                (d) => d.key == 'realDate',
                (d) => [
                    {
                        validator(rule, value, callback, source, options) {
                            if (d.row.isChecked) {
                                if (d.row.realDate === '') {
                                    return callback(
                                        new Error('实际收款日不能为空')
                                    )
                                }
                            }

                            return callback()
                        },
                    },
                ]
            )
        },
        onCheck(row) {
            row.realDate = row.isChecked ? new Date() : ''
            row.payType = ''
        },
    },

    watch: {
        value: {
            handler(val) {
                var list = []
                Object.values(groupBy(val, 'title')).forEach((g) => {
                    var first = g[0]

                    first._merge = {
                        title: {
                            rowspan: g.length,
                        },
                        period: {
                            rowspan: g.length,
                        },
                    }

                    list.push(...g)
                })

                this.list = list
            },
            immediate: true,
        },
    },

    mounted() {
        this.$modal.beforeEnter((next) => {
            Promise.all([this.$dict.get(['pay_type'])])
                .then((args) => {
                    var [group] = args
                    Object.assign(this.dict, group)
                })
                .finally(() => {
                    next()
                })
        })

        this.$modal.onBtnClick('confirm', (next, options) => {
            this.$refs.mt
                .validate()
                .catch((err) => (options.closeModal = false))
                .finally(() => next())
        })
    },
}
</script>

<style></style>
